import { useNavigate } from 'react-router-dom'

import { registrationOpen } from 'pages/auth/view/Register/Register'

import { type AuthPanel } from '../LandingPage'


interface NavbarProps {
    setActivePanel?: (panel: AuthPanel) => void
}

const Navbar = ({
    setActivePanel
}: NavbarProps) => {
    const navigate = useNavigate()

    const handleHome = () => {
        navigate('/')
    }

    return (
        <div className='pf-header'>
            <div className='pf-container pf-header__inner'>
                <div className='pf-header__logo'>
                    <a
                        href='/'
                        onClick={(e) => {
                            e.preventDefault()
                            handleHome()
                        }}
                    >
                        <img src='/logo.png' alt='AllFans Logo' />

                        <img
                        src="/af-dark.svg"
                        alt="AllFans"
                        style={{ height: '1.6rem', width: 'auto' }}
                        />
                    </a>
                </div>

                <ul className='pf-header__menu'>
                    <li>
                        <a
                            href='/'
                            onClick={(e) => {
                                e.preventDefault()
                                handleHome()
                            }}
                        >
                            Home
                        </a>
                    </li>
                </ul>

                <div className='pf-header__actions'>
                    <button
                        onClick={() => {
                            setActivePanel?.('default')

                            setTimeout(() => {
                                setActivePanel?.('login')
                            }, 0)
                        }}
                        className='btn btn-default'
                        data-login
                    >
                        Login
                    </button>

                    <button
                        onClick={() => {
                            setActivePanel?.('default')

                            setTimeout(() => {
                                setActivePanel?.('signup')
                            }, 0)
                        }}
                        className='btn btn-primary'
                        data-signup
                    >
                        {registrationOpen ? 'Sign up' : 'Pre Register'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Navbar